/**
 * @enum {enumColorPickerType} Represents different possible types of color pickers
 */
export enum enumColorPickerType {
  SketchPicker = 'SketchPicker', // Material UI Sketch Color Picker
  TwitterPicker = 'TwitterPicker' // Picker similar to the Twitter Color Picker
}